import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { formValueSelector } from 'redux-form';
import { getInvoiceFetching } from '../../../../../redux/actions/editInvoiceActions';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import EditInvoiceForm from './EditInvoiceForm/EditInvoiceForm';
import { putInvoice } from '../../../../../utils/api';

import CustomModal from '../../../../../shared/components/customComponents/CustomModal/CustomModal';
import AlertComponent from '../../../../../shared/components/customComponents/CustomAlert/CustomAlert';
import Loading from '../../../../../shared/components/Loading';

const EditInvoice = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { errors, loading } = useSelector(state => state.editInvoice);
  const authUser = useSelector(state => state.auth.user);
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const getInvoiceFetchingThunk = getInvoiceFetching(id, authUser.accessToken);
    dispatch(getInvoiceFetchingThunk)
  }, [id, authUser.accessToken, dispatch])

  const handleInvoiceEditForm = (values) => {
    putInvoice(values, id, authUser.accessToken)
      .then(res => {
        if (res.data.success !== true) {
          setErrorMessage(res.data.errors[0].message);
          setErrorModal(!errorModal);
        } else {
          navigate("/financials/invoices");
        }
      })
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <Container>
      <Row>
        <Col xxl={6} xl={8} lg={10} className="col-12">
          <div className="card">
            {errors && (<AlertComponent color="danger">
              <p> {errors}</p>
            </AlertComponent>)}
            <div className="card-body pl-0 pr-0">
              <EditInvoiceForm
                onSubmit={handleInvoiceEditForm}
              />
            </div>
          </div>
          <CustomModal
            successModal={errorModal}
            toggleCloseModal={() => setErrorModal(!errorModal)}
            textModal={errorMessage}
            color={"danger"}
          />
        </Col>
      </Row>
    </Container>
  );
};

const selector = formValueSelector('editInvoiceForm');
export default connect(state => ({
  selectBusiness: selector(state, 'select_business')
}))(EditInvoice)
